import React from 'react';
import {Link} from 'react-router-dom';

const NotFound = () => {
    return (
      <div className="error-page-content">
        <h1 className="errorHeading">404</h1>
        <h2>We couldn't find the page.</h2>
        <p>
          Sorry, the page you are looking for was either not found or doesn't exist.
          Use the search bar above or click the button below to return to the home page.
        </p>
        <Link className="error-btn" to="/">Home Page</Link>
      </div>
    );
};
export default NotFound;